// src/services/licenseService.js

import { API_BASE_URL } from "./apiConfig";
import { logApiContext } from "../config/apiBaseUrl";

const API_URL = `${API_BASE_URL}/api/licenses`;
const logRequest = (action, url) =>
  logApiContext(`licenseService:${action}`, { url, API_URL });

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

const parseError = async (response) => {
  try {
    const data = await response.json();
    return data?.message;
  } catch {
    try {
      return await response.text();
    } catch {
      return null;
    }
  }
};

const handleResponse = async (response, defaultMessage) => {
  if (!response.ok) {
    const msg = (await parseError(response)) || defaultMessage;
    throw new Error(msg);
  }
  return response.json();
};

export const createLicense = async (licenseData) => {
  try {
    const url = `${API_URL}`;
    logRequest("createLicense", url);
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeader(),
      },
      body: JSON.stringify(licenseData),
    });

    return await handleResponse(response, "Error al crear licencia");
  } catch (error) {
    console.error("Error al crear licencia:", error);
    throw error;
  }
};

export const getMyLicenses = async () => {
  logRequest("getMyLicenses", API_URL);
  const response = await fetch(API_URL, { headers: authHeader() });
  return handleResponse(response, "Error al obtener licencias");
};

// Obtiene las licencias que pertenecen al boss autenticado
export const getLicensesByBoss = async () => {
  const url = `${API_URL}/boss`;
  logRequest("getLicensesByBoss", url);
  const response = await fetch(url, {
    headers: authHeader(),
  });
  return handleResponse(response, "Error al obtener licencias del jefe");
};

export const getLicenseById = async (licenseId) => {
  const url = `${API_URL}/${licenseId}`;
  logRequest("getLicenseById", url);
  const response = await fetch(url, {
    headers: authHeader(),
  });
  return handleResponse(response, "Error al obtener licencia");
};

export const updateLicense = async (licenseId, updates) => {
  const url = `${API_URL}/${licenseId}`;
  logRequest("updateLicense", url);
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(updates),
  });
  return handleResponse(response, "Error al actualizar licencia");
};

export const deleteLicense = async (licenseId) => {
  const url = `${API_URL}/${licenseId}`;
  logRequest("deleteLicense", url);
  const response = await fetch(url, {
    method: "DELETE",
    headers: authHeader(),
  });
  return handleResponse(response, "Error al eliminar licencia");
};

// Asigna un Driver a una License concreta
export const assignDriverToLicense = async (licenseId, driverId) => {
  try {
    const url = `${API_URL}/${licenseId}/assign-driver/${driverId}`;
    logRequest("assignDriverToLicense", url);
    const response = await fetch(
      `${API_URL}/${licenseId}/assign-driver/${driverId}`,
      {
        method: "POST",
        headers: authHeader(),
      }
    );
    return await handleResponse(
      response,
      "Error al asignar driver a la licencia"
    );
  } catch (error) {
    console.error("Error al asignar driver a la licencia:", error);
    throw error;
  }
};
